import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ProjectSearchbar } from "@/components/search";
import { PrivatePage, FlexBox } from "@/components";

/**
 * Displays the project search page.
 */
const __default__ = {
  name: "SearchView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), { "full-window": "" }, {
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), {
        "full-width": "",
        justify: "center",
        t: "10"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ProjectSearchbar))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})